import React, { Component } from "react";
import { Document, Page, Outline } from 'react-pdf';
//import { Document, Page, Outline} from 'react-pdf/dist/umd/entry.webpack';
//import { Document, Page, Outline}  from 'react-pdf/dist/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import './FullPagePDFViewer.css';
//import {APIGetpdf } from './Api'
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';

const ColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
    backgroundColor: '#ff3099',
    '&:hover': {
      backgroundColor: '#ff3099',
    },
  },
}))(Button);

export default class FullPagePDFViewer extends Component {
    constructor(props) {
      super(props);
      this.state = {
          numPages: 1,
          pdfFile: null,
          ipage: props.preview_page,
          height: 768,
          width: 1024,
          ratio: 0.75
      }
    }
  
    
  componentDidMount = async() => {     
      //const pdf = await APIGetpdf(this.props.file)
      window.addEventListener("keyup", this.keyHandling);	
      const {width,height} = this.getWindowDimensions()   
      const ratio = height / width   
      this.setState({pdfFile: this.props.file, width,height, ratio} )


      this.toggleFullScreen()
  }


getWindowDimensions= () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
toggleFullScreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  keyHandling = (e) => {	    
    // Handle event	    
    console.log("Key code: " + e.keyCode);	 
    switch(e.keyCode) {
      case 37:
          this.Back();
          break;
      case 39:
          this.Forward();
          break;
      case 27:
        this.toggleFullScreen()
        this.props.ClosePreview()
        break;
    } 
  }	  	  
    
	  
  componentWillUnmount =() => {	    
    // Remove event listener on compenent unmount	    
    window.removeEventListener("keyup", this.keyHandling);	  
  }	

 onDocumentLoadSuccess = (pdf) => {
   console.log("Numpages = "+ pdf.numPages)
    this.setState({numPages: pdf.numPages})
  }
loadError = (err) => {
  console.log(err)
} 

Forward = () => {
  var ipage = this.state.ipage
  console.log(ipage)
  console.log(this.state.numPages)
  if(ipage < this.state.numPages) {
    ipage++
    console.log(ipage)
    this.setState({ipage})
  }
  this.props.onChange(ipage)
}

Back = () => {
  var ipage = this.state.ipage
  if(ipage > 0) {
    ipage--
    this.setState({ipage})
  }  
  this.props.onChange(ipage)
}
DocClick = (event) => {
  this.Forward()
}

PageClick = (event) => {
  console.log("DocClick")
  console.log(event.target)
}

KeyPress = (event) => {
  console.log(event.target.value)
}
  render() {
    const {width,height,ratio} = this.state
    const dwidth = width - 200
    const dheight = height - (200 * ratio)
    return (

      <div style={{alignItems: "center", textAlign: 'center'}} onKeyPress={this.KeyPress}>
          { 1== 2 && <span style={{fontSize: '24px', fontWeight: 600, color: 'black', textAlign: 'center' }}>&nbsp;&nbsp;&nbsp;MT Solar Ltd&nbsp;&nbsp;&nbsp;</span> }
        <div className="PDFViewer__container">
   
          <div className="PDFViewer__container__document">
            <Document

              loading=''
              noData='Sorry There is No Data'
              file={this.state.pdfFile}
              onLoadSuccess={this.onDocumentLoadSuccess}
              onLoadError={this.loadError}
              renderMode="svg"
              style={{alignItems: 'center'}}
              onClick={this.DocClick}
            >
            <Page 
                          height = {height}
                          width = {width}
            
            onClick={this.PageClick}
                renderMode="svg"
                loading=''
                noData={<div style={{color: 'black'}} >PDF Pages Loading...</div>}
                pageNumber={this.state.ipage}  style={{alignItems: 'center'}}
            />              
            <Outline/>
            </Document>
         </div>
       
         </div>
                
         </div>
    )
  }
}